module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0042.jpg?v=a5d7be57";